import React from 'react';

class CountryAssistanceSeekingPOASection extends React.Component {
  findTopicByAbbreviation(abbreviation) {
    const thematicArray = Object.values(this.props.thematicDict);
    return thematicArray.find(item => item.abbreviation === abbreviation);
  }

  getThematicColor(abbreviation) {
    const topic = this.findTopicByAbbreviation(abbreviation);
    return topic && topic.colorCode ? topic.colorCode : this.props.defaultColor;
  }

  getFullTopicName(abbreviation) {
    const topic = this.findTopicByAbbreviation(abbreviation, this.props.thematicDict);
    return topic && topic.fullTopicName ? topic.fullTopicName : ' ';
  }

  renderProposal() {
    if (!this.props.data.attributes.hasProposal) return null;

    return (
      <a className="proposal-developed-tag pull-right"
        target="_blank" href="https://www.un.org/disarmament/project-proposals/"
        rel="noopener noreferrer"
        style={{ marginTop: '13px', marginLeft: '5px' }}
      >
        &nbsp;Proposal developed
      </a>
    );
  }

  render() {
    const data = this.props.data.attributes,
      thematicColor = this.getThematicColor(data.abbreviation),
      borderStyle =`3px solid ${thematicColor}`;

    return (
      <div>
        <span className="tag-table-tag" style={{ backgroundColor: thematicColor }}>
          { data.abbreviation }
        </span>
        <h4 className="assistance-topic-heading inline-heading">
          { data.topic }
        </h4>
        <div className="blockquote-wrapper row" style={{ borderTop: borderStyle }}>
          <div className="col-md-9">
            <h4 className="blockquote-label">
              <small>Description of needs: </small>
            </h4>
            <blockquote className="blockquote blockquote-quoted">
              <p className="mb-0"> { data.description || "No description provided" } </p>
            </blockquote>
          </div>

          <div className="col-md-3">
            { this.renderProposal() }
          </div>
        </div>
      </div>
    )
  }
}

export default CountryAssistanceSeekingPOASection;



// WEBPACK FOOTER //
// ./src/components/CountryAssistance/CountryAssistanceSeekingPOASection.js